import builder from '../builder';
import View1 from '../../streamline-icons/bold/view-1.svg';

export default builder('IconView1Bold', View1);
